var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "google-play-reviews-page" },
    [
      _c("div", { staticClass: "reviews-panel" }, [
        _c("div", { staticClass: "panel-header" }, [
          _c("h2", { staticClass: "panel-title" }, [
            _c("span", { staticClass: "material-icons google-icon" }, [
              _vm._v("star"),
            ]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("googlePlay.reviews")) +
                "\n                "
            ),
            _c("span", { staticClass: "count-badge" }, [
              _vm._v(_vm._s(_vm.total)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    placeholder: _vm.$t("googlePlay.selectApp"),
                    size: "small",
                    allowClear: "",
                  },
                  model: {
                    value: _vm.filters.appId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "appId", $$v)
                    },
                    expression: "filters.appId",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.allApps"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.apps, function (app) {
                    return _c(
                      "a-select-option",
                      { key: app._id, attrs: { value: app._id } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("truncate")(app.appName, 40)) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { size: "small" },
                  model: {
                    value: _vm.filters.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "status", $$v)
                    },
                    expression: "filters.status",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.all"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "new" } }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.new"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "replied" } }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.replied"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "resolved" } }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.resolved"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { size: "small" },
                  model: {
                    value: _vm.filters.starRating,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "starRating", $$v)
                    },
                    expression: "filters.starRating",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.allRatings"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: 5 } }, [
                    _vm._v("5 Stars"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: 4 } }, [
                    _vm._v("4 Stars"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: 3 } }, [
                    _vm._v("3 Stars"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: 2 } }, [
                    _vm._v("2 Stars"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: 1 } }, [
                    _vm._v("1 Star"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { size: "small", loading: _vm.loading },
                  on: { click: _vm.fetchReviews },
                },
                [_c("a-icon", { attrs: { type: "reload" } })],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "reviews-list" },
              [
                _vm._l(_vm.reviews, function (review) {
                  return _c(
                    "div",
                    {
                      key: review._id,
                      staticClass: "review-item",
                      class: {
                        selected:
                          _vm.selectedReview &&
                          _vm.selectedReview._id === review._id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectReview(review)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "material-icons avatar-placeholder" },
                        [_vm._v("account_circle")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "review-main" }, [
                        _c("div", { staticClass: "review-top" }, [
                          _c("span", { staticClass: "author-name" }, [
                            _vm._v(_vm._s(review.authorName)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "review-date" }, [
                            _vm._v(_vm._s(_vm.formatDate(review.createTime))),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "status-dot",
                            class: review.status,
                            attrs: { title: _vm.getStatusLabel(review.status) },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "star-rating" },
                          [
                            _vm._l(review.starRating, function (n) {
                              return _c(
                                "span",
                                {
                                  key: "filled-" + n,
                                  staticClass: "material-icons",
                                },
                                [_vm._v("star")]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(5 - review.starRating, function (n) {
                              return _c(
                                "span",
                                {
                                  key: "empty-" + n,
                                  staticClass: "material-icons empty",
                                },
                                [_vm._v("star_border")]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        review.comment
                          ? _c("p", { staticClass: "review-text" }, [
                              _vm._v(
                                _vm._s(_vm.truncateText(review.comment, 120))
                              ),
                            ])
                          : _c("p", { staticClass: "review-text no-comment" }, [
                              _vm._v(_vm._s(_vm.$t("googlePlay.noComment"))),
                            ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "review-bottom" }, [
                          review.app
                            ? _c("span", { staticClass: "app-link" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("android"),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("truncate")(review.app.appName, 25)
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          review.appVersionName
                            ? _c("span", { staticClass: "version-badge" }, [
                                _vm._v(
                                  "\n                            v" +
                                    _vm._s(review.appVersionName) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "review-actions-mini" },
                        [
                          _c(
                            "a-dropdown",
                            {
                              attrs: { trigger: ["click"] },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "overlay",
                                    fn: function () {
                                      return [
                                        _c(
                                          "a-menu",
                                          [
                                            _c(
                                              "a-sub-menu",
                                              {
                                                key: "status",
                                                attrs: {
                                                  title:
                                                    _vm.$t("googlePlay.status"),
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "new",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateStatus(
                                                          review,
                                                          "new"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "status-indicator new",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "googlePlay.new"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "replied",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateStatus(
                                                          review,
                                                          "replied"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "status-indicator replied",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "googlePlay.replied"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "resolved",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateStatus(
                                                          review,
                                                          "resolved"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "status-indicator resolved",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "googlePlay.resolved"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("a-menu-divider"),
                                            _vm._v(" "),
                                            _c(
                                              "a-menu-item",
                                              {
                                                key: "reply",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openReplyModal(
                                                      review
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "message" },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("googlePlay.reply")
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "a-button",
                                { attrs: { size: "small", type: "link" } },
                                [_c("a-icon", { attrs: { type: "more" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.reviews.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("reviews"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("googlePlay.noReviewsFound"))),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _c("div", { staticClass: "loading-state" }, [_c("a-spin")], 1),
        _vm._v(" "),
        _vm.total > _vm.pagination.limit
          ? _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("a-pagination", {
                  attrs: {
                    current: _vm.pagination.page,
                    total: _vm.total,
                    "page-size": _vm.pagination.limit,
                    size: "small",
                    "show-size-changer": "",
                    "page-size-options": ["20", "50", "100"],
                  },
                  on: {
                    change: _vm.onPageChange,
                    showSizeChange: _vm.onPageSizeChange,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.selectedReview
        ? _c("div", { staticClass: "detail-panel" }, [
            _c("div", { staticClass: "detail-header" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("account_circle"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "author-details" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.selectedReview.authorName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "date" }, [
                  _vm._v(_vm._s(_vm.formatDate(_vm.selectedReview.createTime))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "badges" }, [
                _c(
                  "span",
                  {
                    staticClass: "status-badge",
                    class: _vm.selectedReview.status,
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.getStatusLabel(_vm.selectedReview.status))
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "star-rating-large" },
              [
                _vm._l(_vm.selectedReview.starRating, function (n) {
                  return _c(
                    "span",
                    { key: "filled-" + n, staticClass: "material-icons" },
                    [_vm._v("star")]
                  )
                }),
                _vm._v(" "),
                _vm._l(5 - _vm.selectedReview.starRating, function (n) {
                  return _c(
                    "span",
                    { key: "empty-" + n, staticClass: "material-icons empty" },
                    [_vm._v("star_border")]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.selectedReview.comment
              ? _c("div", { staticClass: "detail-body" }, [
                  _vm._v(_vm._s(_vm.selectedReview.comment)),
                ])
              : _c("div", { staticClass: "detail-body no-comment" }, [
                  _vm._v(_vm._s(_vm.$t("googlePlay.noComment"))),
                ]),
            _vm._v(" "),
            _vm.selectedReview.device || _vm.selectedReview.androidOsVersion
              ? _c("div", { staticClass: "device-info" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.$t("googlePlay.deviceInfo"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-grid" }, [
                    _vm.selectedReview.device
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("googlePlay.device")) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.selectedReview.device)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedReview.androidOsVersion
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Android:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              "API " +
                                _vm._s(_vm.selectedReview.androidOsVersion)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedReview.appVersionName
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("googlePlay.appVersion")) + ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.selectedReview.appVersionName)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedReview.deviceMetadata &&
                    _vm.selectedReview.deviceMetadata.manufacturer
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("googlePlay.manufacturer")) + ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.selectedReview.deviceMetadata.manufacturer
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedReview.reply && _vm.selectedReview.reply.text
              ? _c("div", { staticClass: "reply-section" }, [
                  _c("div", { staticClass: "reply-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("reply"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("googlePlay.yourReply")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "reply-content" }, [
                    _vm._v(_vm._s(_vm.selectedReview.reply.text)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "reply-date" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatDate(_vm.selectedReview.reply.lastModified)
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "detail-actions" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openReplyModal(_vm.selectedReview)
                      },
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "message" } }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.selectedReview.reply
                            ? _vm.$t("googlePlay.updateReply")
                            : _vm.$t("googlePlay.reply")
                        ) +
                        "\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-dropdown",
                  {
                    attrs: { trigger: ["click"] },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                {
                                  on: {
                                    click: function (e) {
                                      return _vm.updateStatus(
                                        _vm.selectedReview,
                                        e.key
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("a-menu-item", { key: "new" }, [
                                    _vm._v(_vm._s(_vm.$t("googlePlay.new"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-menu-item", { key: "replied" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("googlePlay.replied"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-menu-item", { key: "resolved" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("googlePlay.resolved"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3912267577
                    ),
                  },
                  [
                    _c(
                      "a-button",
                      { attrs: { size: "small" } },
                      [
                        _vm._v(_vm._s(_vm.$t("googlePlay.status")) + " "),
                        _c("a-icon", { attrs: { type: "down" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "detail-panel empty" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("rate_review"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("googlePlay.selectReviewToPreview"))),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("googlePlay.replyToReview"),
            "confirm-loading": _vm.replyModal.loading,
            width: "500px",
          },
          on: { ok: _vm.submitReply },
          model: {
            value: _vm.replyModal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.replyModal, "visible", $$v)
            },
            expression: "replyModal.visible",
          },
        },
        [
          _vm.replyModal.review
            ? _c("div", { staticClass: "reply-preview" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("account_circle"),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.replyModal.review.authorName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "star-rating-small" },
                    _vm._l(_vm.replyModal.review.starRating, function (n) {
                      return _c(
                        "span",
                        { key: "filled-" + n, staticClass: "material-icons" },
                        [_vm._v("star")]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.replyModal.review.comment
                    ? _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.truncateText(_vm.replyModal.review.comment, 200)
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("a-textarea", {
            attrs: {
              placeholder: _vm.$t("googlePlay.writeYourReply"),
              rows: 4,
              maxLength: 350,
            },
            model: {
              value: _vm.replyModal.text,
              callback: function ($$v) {
                _vm.$set(_vm.replyModal, "text", $$v)
              },
              expression: "replyModal.text",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "char-count" }, [
            _vm._v(_vm._s(_vm.replyModal.text.length) + "/350"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }